import { IPlantPlanet } from 'src/commons';
import { PlantPlanetActionTypes, PlantPlanetActions } from './plant-planet.actions';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IPlantPlanet | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: PlantPlanetActions): State {
    switch (action.type) {

        case PlantPlanetActionTypes.LoadPlantPlanetState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PlantPlanetActionTypes.LoadPlantPlanetStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case PlantPlanetActionTypes.LoadPlantPlanetStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case PlantPlanetActionTypes.PlantPlanetScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;